import React from 'react';
import ReactDOM from 'react-dom';

import ImgIconComp from '../../imgcomp';
import { withTranslation } from 'react-i18next';

class ViewEndPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: true,
      valueStr: 1,
      isRate: true,
      valueRate: this.props.meetingObj.type == 1 ? 0 : 1,
    };
    this.toggleChange = this.toggleChange.bind(this);
    this.toggleRateChange = this.toggleRateChange.bind(this);
    this.closeWsPopup = this.closeWsPopup.bind(this);
    this.endMeetingPopUp = this.endMeetingPopUp.bind(this);
  }

  toggleChange() {
    this.setState({
      isChecked: !this.state.isChecked,
      valueStr: !this.state.valueStr,
    });
    if (this.state.valueStr == 1) {
      this.setState({
        valueStr: 0,
      });
    } else {
      this.setState({
        valueStr: 1,
      });
    }
  }

  toggleRateChange() {
    this.setState({
      isRate: !this.state.isRate,
      valueRate: !this.state.valueRate,
    });
    if (this.state.valueRate == 1) {
      this.setState({
        valueRate: 0,
      });
    } else {
      this.setState({
        valueRate: 1,
      });
    }
  }

  closeWsPopup() {
    if (document.getElementById('delete-meeting-confirm-box')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('delete-meeting-confirm-box'));
    }
    $(delete_meeting_confirm).dialog('close');
  }

  endMeetingPopUp(e) {
    // TODO: move to action level 
    const { actions } = this.props;
    const fromWhere = this.props.sendSum;
    const sendSummarytoInvity = this.state.valueStr;
    const sendSummaryRate = this.props.meetingObj.type == 1 ? 0 : this.state.valueRate;

    // unregister meet event
    unregister('meet');
    const meetingId = this.props.meetingObj.id;
    const groupMeeting = (this.props.meetingObj.type != 1) ? 1 : 0;
    const sendMinuteParam = (this.props.sendMinute) ? 1 : 0;
    if (fromWhere == 1) {
      const state = 0;
      $.post(`${wbConfig.baseUrl}/meeting/sendSummary`, {
        id: meetingId, groupMeeting, invitees: sendSummarytoInvity, rate: sendSummaryRate, sendMinuteParam,
      });
      $(delete_meeting_confirm).dialog('close');
      $.post(`${wbConfig.baseUrl}/meeting/sendMinutesUpdate`, { id: meetingId, send_minutes: state });
      actions.MeetingsMinuteStateUpdate(state);
    } else {
      const meetingDeleteConfirm = $(this).closest('#delete-meeting-confirm-box');
      this.props.endMeetingOnce(sendSummarytoInvity, meetingDeleteConfirm, sendSummaryRate, sendMinuteParam);
    }
    $(document).trigger('unmount_meeting_app_comp');
  }

  render() {
    const { t } = this.props;
    const { sendMinute } = this.props;
    const { meetingObj } = this.props;
    return (
      <div className="wbmodal" id="delete-meeting-confirm-box" data-mid={this.props.meetingObj.id} data-close-future={this.props.future}>
        <div className="wbmodal-header">
          <div className="wbmodal-htitle left">
            {
              sendMinute
                ? <b>{t('Send Meeting Minutes')}</b>
                : <b>{t('Close Meeting')}</b>
            }
          </div>
          <div className="wbmodal-hcancel closeWsPopup right clickable" onClick={this.closeWsPopup}>
            <ImgIconComp id="close" />
          </div>
          <div className="clear" />
        </div>

        <div className="confimContentBlock">
          {
            sendMinute
              ? <p className="confirmSubHead modalMainParaText">{t('What would you like to do')}?</p>
              : <p className="confirmSubHead modalMainParaText">{ this.props.future == '1' ? t("Are you sure you want to close a meeting that (technically) hasn't occurred yet.") : t('Are you sure you want to close this meeting?')}</p>
          }
          <div style={{ margin: '15px 0px' }}>
            <div className="chkbox">
              <input className="css-checkbox" checked={this.state.isChecked} type="checkbox" value={this.state.valueStr} name="ssummary_send" id="ssummary_send" onChange={this.toggleChange} />
              <label className="css-label modalParaText" htmlFor="ssummary_send" />
              <span className="textSendSummary">{t('Send summary to attendees')}</span>
            </div>
          </div>
          {
            meetingObj.type != 1
            && (
            <div style={{ margin: '15px 0px' }}>
              <div className="chkbox">
                <input className="css-checkbox" checked={this.state.isRate} type="checkbox" value={this.state.valueRate} name="ssummary_rate" id="ssummary_rate" onChange={this.toggleRateChange} />
                <label className="css-label modalParaText" htmlFor="ssummary_rate" />
                <span className="textSendSummary">{t('Ask attendees to rate this meeting')}</span>
              </div>
            </div>
            )
          }
        </div>
        <div className="wbmodal-content floatRight">
          <div className="gbl-butn-wraper">
            <div className="gbl-btn" onClick={e => this.endMeetingPopUp(e)}>Yes</div>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(ViewEndPopup);
